import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { INivelesPromo, IProductos } from '../../../../private/shared/models/productos';
import { EventInteraction, GTMInteractions } from '../../../models/Constants';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-products-level',
  templateUrl: './products-level.component.html',
  styleUrls: ['./products-level.component.scss'],
})
export class ProductsLevelComponent implements OnInit, OnChanges {

  @Input() Niveles: INivelesPromo[] = [];
  @Input() productosPromocion: IProductos[] = [];
  @Input() cartPromoProducts: IProductos[] = [];
  @Input() level = 0;
  @Input() disabledEdit = true;
  @Input() isBonus = true;

  @Output() comeNivelProducts = new EventEmitter<{ Niveles: INivelesPromo[], cartPromoProducts: IProductos[] }>()

  public refNiveles: INivelesPromo[] = [];
  public disabledNextStates: { [nivel: number]: boolean } = {};

  constructor(
    private analytics: AnalyticsService
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.Niveles && changes.Niveles.currentValue) {
      this.refNiveles = JSON.parse(JSON.stringify(this.Niveles));
      this.calculateDisabledNextAll();
    }
  }

  /** Pasa por referencia el estado del carrito y nivel los productos seleccionados */
  public productUse = (product: IProductos, nivel: number) => {
    this.cartPromoProducts = this.cartPromoProducts.map(p => {
      if (product.id_producto === p.id_producto && product.Nivel === p.Nivel) {
        return product;
      }
      return p;
    });

    const productsUses = this.cartPromoProducts.filter(p => p.Nivel === nivel);
    // Modifica por referencia para evitar recrear el array y re-renderizado completo
    const targetLevel = this.useMaxRange(nivel);
    if (targetLevel) {
      targetLevel.Minimo = productsUses.map(x => x.productos).reduce((a, b) => a + b, 0);
    }
    this.calculateDisabledNextAll();
  }

  // Calcula el estado disabled para todos los niveles y almacena en un objeto
  public calculateDisabledNextAll() {
    this.disabledNextStates = {};
    this.refNiveles.forEach(nivel => this.disabledNextStates[nivel.Nivel] = this.disabledNext(nivel.Nivel));
  }

  /** Desactiva el boton del siguiente nivel si no completa los productos seleccionables */
  public disabledNext = (nivel: number) => {
    const level = this.useMaxRange(nivel);
    return level ? level.Minimo < level.Maximo : true;
  }

  /** Retorna el nivel de referencia */
  public useMaxRange = (nivel: number) => this.refNiveles.find(n => n.Nivel === nivel);

  /** Cambia de nivel y retorna los valores */
  public onNext = (level: number) => {
    if (this.disabledNextStates[level + 1]) return;
    this.level = level + 1;
    this.comeNivelProducts.emit({ Niveles: this.refNiveles, cartPromoProducts: this.cartPromoProducts });
    this.disabledEdit = false;
    const eventAction = this.validLevels() ? GTMInteractions.nextLevelPromoDynamicEvent : GTMInteractions.updateDynamicPromoEvent;
    this.analytics.sendEventAnalytics(eventAction, EventInteraction);
  }

  /** Pueda editar la promo */
  public onEdit = (level: number) => {
    if (this.validLevelEdit()) return;
    this.level = level;
    this.disabledEdit = true;
  }

  /** Si cumple con los niveles */
  public validLevels = () => this.Niveles.some(n => n.Maximo > n.Minimo);

  /** Verifica si un nivel puede ser editado (cumple con el mínimo de productos) */
  public validLevelEdit = () => this.refNiveles.some(n => n.Maximo > n.Minimo);

}
